<template>
  <transition :name="fast ? 'fade-fast' : 'fade'">
    <div v-show="visible" class="modal-window" @click="$emit('dismiss', true)">
      <div class="modal-window-content" style="overflow-y: auto">
        <div :class="hasContainer ? 'container' : null" @click.stop>
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'Modal',
    props: {
      visible: { type: Boolean, default: false },
      hasContainer: { type: Boolean, default: true }, // adds additional padding so clicking outside will dismiss
      fast: { type: Boolean, default: false },
    },
    emits: ['dismiss'],
  }
</script>

<style>
  .modal-window {
    z-index: 3;
    padding-top: 100px;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
  }

  .modal-window-content {
    z-index: 5;
    position: fixed;
    width: 96%;
    height: 96%;
    top: 2%;
    left: 2%;
    overflow: hidden;
  }
</style>
